import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Navbar from "./Navbar";
import LoadingSpinner from "./LoadingSpinner";

const EditInternshipForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [internship, setInternship] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchInternship = async () => {
      try {
        const snap = await getDoc(doc(db, "internships", id));
        if (snap.exists()) {
          setInternship(snap.data());
        }
      } catch (error) {
        console.error("Error fetching internship:", error);
      }
      setLoading(false);
    };
    fetchInternship();
  }, [id]);

  const handleUpdate = async () => {
    setSaving(true);
    try {
      await updateDoc(doc(db, "internships", id), internship);
      navigate("/manage-opportunities");
    } catch (error) {
      console.error("Error updating internship:", error);
    }
    setSaving(false);
  };

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInternship({ ...internship, [field]: value });
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <LoadingSpinner />
      </div>
    );
  }

  if (!internship) {
    return (
      <div className="min-h-screen bg-slate-50">
        <Navbar />
        <div className="page-container text-center py-20">
          <p className="text-gray-500">Internship not found.</p>
          <button onClick={() => navigate("/manage-opportunities")} className="button btn-primary mt-4">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="page-container max-w-2xl">
        <div className="mb-6">
          <button
            onClick={() => navigate("/manage-opportunities")}
            className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Manage
          </button>
          <h1 className="section-title">Edit Internship</h1>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 p-6 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
              <input value={internship.title || ""} onChange={handleChange("title")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
              <input value={internship.company || ""} onChange={handleChange("company")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
              <input value={internship.location || ""} onChange={handleChange("location")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Apply Link</label>
              <input value={internship.applyLink || ""} onChange={handleChange("applyLink")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Stipend</label>
              <input type="number" value={internship.stipend || ""} onChange={handleChange("stipend")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Duration (months)</label>
              <input type="number" value={internship.duration || ""} onChange={handleChange("duration")} className="input-field" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Deadline</label>
              <input type="date" value={internship.deadline || ""} onChange={handleChange("deadline")} className="input-field" />
            </div>
          </div>

          <div className="flex items-center gap-6 pt-2">
            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
              <input type="checkbox" checked={internship.paid || false} onChange={handleChange("paid")} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
              Paid
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
              <input type="checkbox" checked={internship.remote || false} onChange={handleChange("remote")} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
              Remote
            </label>
          </div>

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-100">
            <button onClick={() => navigate("/manage-opportunities")} className="button btn-secondary">
              Cancel
            </button>
            <button onClick={handleUpdate} disabled={saving} className="button btn-primary">
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInternshipForm;
